import { Controller } from "@hotwired/stimulus"

// Intercepts a form submit and asks for confirmation before an action that removes
// the employee's account: the settings form (deactivation) and the archive button.
//
// With a checkbox target, it only prompts when that box is newly checked. Without
// one the form exists solely to perform the destructive action, so it always prompts.
export default class extends Controller {
  static targets = ["checkbox", "dialog"]

  guard(event) {
    if (this.confirmed) return
    if (!this.destructive) return

    event.preventDefault()
    this.dialogTarget.showModal()
  }

  // Without a checkbox the form does nothing but the destructive action. With one,
  // only a newly checked box is destructive (an already-checked box on page load
  // means the employee is deactivated already).
  get destructive() {
    if (!this.hasCheckboxTarget) return true

    return this.checkboxTarget.checked && !this.checkboxTarget.defaultChecked
  }

  confirm() {
    this.confirmed = true
    this.dialogTarget.close()
    // The controller element is either the form itself (settings form) or a wrapper
    // around it (archive button, which needs the dialog as a sibling of the form).
    const form =
      this.element instanceof HTMLFormElement ? this.element : this.element.querySelector("form")
    form.requestSubmit()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
